<template>
  <div>
    <div class="row q-col-gutter-md q-mb-xm" />
    <div class="row q-mb-sm q-mt-lg">
      <div class="text-bold">
        Initial Values
      </div>
    </div>
    <div
      class="row q-mb-md"
    >
      <q-tabs
        v-if="$q.screen.gt.xs"
        v-model="section.initialNewsItemClassId"
        dense
        no-caps
        style="border: 1px solid #ccc"
        class="q-pa-xs size-md q-mr-sm"
        active-color="white"
        active-bg-color="primary"
        indicator-color="transparent"
        align="justify"
      >
        <q-tab
          v-for="newsItemClass in newsItemClassTabs"
          :key="newsItemClass.key"
          :name="newsItemClass.name"
          :label="newsItemClass.label"
          :style="newsItemClass.style"
        />
      </q-tabs>
      <q-select
        v-else
        v-model="section.initialNewsItemClassId"
        no-caps
        :options="newsItemClassTabs"
        class="col-5"
        filled
        bg-color="transparent"
        map-options
        emit-value
      />
    </div>
    <div class="row q-mb-sm q-mt-lg">
      <div class="text-bold">
        Filter Display
      </div>
    </div>
    <div class="row q-col-gutter-md q-mb-sm">
      <q-select
        v-model="section.newsItemClassIds"
        class="col-9"
        label="News Item Classes"
        :options="newsItemClasses.data"
        multiple
        option-label="name"
        option-value="id"
        emit-value
        bottom-slots
        @update:model-value="changeCount++"
      >
        <template #selected-item="scope">
          <q-chip
            removable
            dense
            :tabindex="scope.tabindex"
            :label="newsItemClassNames[scope.opt]"
            @remove="scope.removeAtIndex(scope.index)"
          />
        </template>
        <template #option="scope">
          <q-item
            v-bind="scope.itemProps"
            v-on="scope.itemEvents"
          >
            <q-item-section>
              {{ scope.opt.name }}
            </q-item-section>
          </q-item>
        </template>
      </q-select>
      <q-checkbox
        v-model="section.config.showNewsItemClasses"
        class="col-3 q-pb-md"
        label="Show News Item Class Control"
        bottom-slots
      />
    </div>
    <div class="row q-mb-sm">
      <div class="text-bold">
        Display
      </div>
    </div>
    <div class="row q-col-gutter-md q-mb-sm">
      <q-checkbox
        v-model="section.config.showExploreNewsHeading"
        class="col-6 col-sm-3"
        label="Show Heading"
        bottom-slots
      />
      <q-checkbox
        v-model="section.config.showExploreNewsItemBanner"
        class="col-6 col-sm-3"
        label="Show Banner Image"
        bottom-slots
      />
      <q-checkbox
        v-model="section.config.showExploreNewsItemTitle"
        class="col-6 col-sm-3"
        label="Show Title"
        bottom-slots
      />
      <q-checkbox
        v-if="!section.config.showExploreNewsItemDate"
        v-model="section.config.showExploreNewsItemSubtitle"
        class="col-6 col-sm-3"
        label="Show Subtitle Banner"
        bottom-slots
      />
      <q-checkbox
        v-model="section.config.showExploreNewsItemDescription"
        class="col-6 col-sm-3"
        label="Show Description"
        bottom-slots
      />
      <q-checkbox
        v-model="section.config.showExploreNewsItemButton"
        class="col-6 col-sm-3"
        label="Show Button"
        bottom-slots
      />
      <q-checkbox
        v-model="section.config.showExploreNewsItemClassNames"
        class="col-6 col-sm-3"
        label="Show News Item Class"
        bottom-slots
      />
      <q-checkbox
        v-model="section.config.showExploreNewsItemDate"
        class="col-6 col-sm-3"
        label="Show Date"
        bottom-slots
      />
      <q-select
        v-if="section.config.showExploreNewsItemDate"
        v-model="section.config.exploreNewsItemDateType"
        class="col-6 col-sm-3"
        label="Default Date Type"
        :options="exploreNewsItemDateTypeOptions"
        map-options
        emit-value
      />
      <q-input
        v-model.number="section.config.exploreNewsNumberOfNewsOnShow"
        class="col-6 col-sm-3"
        label="Number of News on Show"
        type="number"
        min="0"
        max="60"
        step="1"
      >
        <q-tooltip>Leave empty to show all news feeds</q-tooltip>
      </q-input>
    </div>
    <div class="row q-mb-sm">
      <div class="text-bold">
        Style
      </div>
    </div>
    <div class="row q-col-gutter-md q-mb-sm">
      <div
        class="col-6 col-sm-3"
      >
        <q-item-label>Maximum News Per Row</q-item-label>
        <q-slider
          v-model="section.config.exploreNewsMaxItemPerRow"
          label
          label-always
          switch-label-side
          type="number"
          :min="2"
          :max="5"
          :step="1"
        />
      </div>
      <div
        class="col-6 col-sm-3"
      >
        <q-item-label>News Padding</q-item-label>
        <q-slider
          v-model="section.config.exploreNewsItemPadding"
          label
          label-always
          switch-label-side
          type="number"
          :min="0"
          :max="30"
          :step="1"
        />
      </div>
      <div
        class="col-6 col-sm-3"
      >
        <q-item-label>Border Radius</q-item-label>
        <q-slider
          v-model="section.config.exploreNewsItemBorderRadius"
          label
          label-always
          switch-label-side
          type="number"
          :min="0"
          :max="20"
          :step="1"
        />
      </div>
      <div
        class="col-6 col-sm-3"
      >
        <q-item-label>Shadow</q-item-label>
        <q-slider
          v-model="section.config.exploreNewsItemShadow"
          label
          label-always
          switch-label-side
          type="number"
          :min="0"
          :max="10"
          :step="1"
        />
      </div>
      <color-selection
        class="col-12 col-sm-6"
        :color-name="section.config.exploreNewsItemBackgroundColor"
        :custom-color-hex="section.config.exploreNewsItemBackgroundColorHex"
        label="Background Color"
        @update:model-value="setPosterBackgroundColor"
      />
      <q-checkbox
        v-model="section.config.isExploreNewsItemTextCentre"
        class="col-6 col-sm-3"
        label="Text Centred"
        bottom-slots
      />
      <q-checkbox
        v-model="section.config.isExploreNewsItemTextLight"
        class="col-6 col-sm-3"
        label="Light Text"
        bottom-slots
      />
      <q-checkbox
        v-model="section.config.exploreNewsItemKeepImageRatio"
        class="col-6 col-sm-3"
        label="Keep Original Image Aspect Ratio"
        bottom-slots
      />
    </div>
    <preview
      :key="changeCount"
      :section="section"
      class="q-mb-xl"
    />
  </div>
</template>

<script>

import Section, { DISPLAY_DATE_TYPES } from 'src/models/page/Section'
import ColorSelection from 'src/modules/admin/components/ColorSelection'
import Preview from 'src/modules/consumer/components/Preview'

export default {
  name: 'ExploreNewsEditor',
  components: {
    Preview,
    ColorSelection
  },
  props: {
    section: {
      type: Section,
      required: true
    }
  },
  configuration: ['publishedNewsItems', 'newsItemClasses'],
  data () {
    return {
      changeCount: 0
    }
  },
  computed: {
    newsItemClassNames () {
      const newsItemClassNames = {}

      _.each(this.newsItemClasses.data, newsItemClass => {
        newsItemClassNames[newsItemClass.id] = newsItemClass.name
      })

      return newsItemClassNames
    },
    newsItemClassTabs () {
      const newsItemsClassTabs = [{
        key: null,
        name: null,
        value: null,
        label: this.$i18n.t('collection.all'),
        style: `{'border-radius' : ${this.newsItemBorderRadius}px}`
      }]

      _.each(this.newsItemClasses.data, newsItemClass => {
        if (_.includes(this.section.newsItemClassIds, newsItemClass.id)) {
          newsItemsClassTabs.push({
            key: newsItemClass.id,
            name: newsItemClass.id,
            value: newsItemClass.id,
            label: newsItemClass.name,
            style: `{'border-radius' : ${this.newsItemBorderRadius}px}`
          })
        }
      })

      return newsItemsClassTabs
    }
  },
  created () {
    _.extend(this, {
      exploreNewsItemDateTypeOptions: this.$mh.asOptions(DISPLAY_DATE_TYPES),
      DISPLAY_DATE_TYPES
    })
  },
  methods: {
    setPosterBackgroundColor (colorName, customColorHex) {
      this.section.config.exploreNewsItemBackgroundColor = colorName
      this.section.config.exploreNewsItemBackgroundColorHex = customColorHex
    }
  }
}

</script>

<style lang="scss" scoped>
.desktop-preview {
  width: 1024px;
  height: 700px;
  border: solid 5px #666;
  border-radius: 10px;
}

.mobile-preview {
  width: 400px;
  height: 800px;
  border: solid 5px #666;
  border-radius: 10px;
}
</style>
